/**
 * サンプルクラス
 * @constructor
 */
class Ipad {
  constructor() {

  }
  /**
   * サンプル
   */
  init() {
    //下記の内容はheader_footer_inc.js内のiPadAct()に移植

    // var ua = navigator.userAgent;
    // if (ua.indexOf('iPad') > 0) {
    //   $(".m-kv").prepend('<div class="m-kv__cover"></div>');
    //   $(".m-botConts").removeClass('m-botConts--top');
    //   $(".l-header").css('min-width','1200px');
    //   $(".l-header__inner").css({
    //     'margin':'0'
    //   });
    // }
  }
};

export default Ipad;
